import { AutoRenewalDeactivationCondition } from "~/generated/graphql";
import type { DisclaimerKeysMap } from "../contract";

const DISCLAIMER_KEYS: DisclaimerKeysMap = {
  [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_12ConsecutiveMonthlyRenewals]:
    "membershipWithInstallmentsDisclaimer.yearlyPaidMonthly",
  [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_4ConsecutiveQuarterlyRenewals]:
    "membershipWithInstallmentsDisclaimer.yearlyPaidQuarterly",
};

export const DISCLAIMER_KEYS_NO_WRAPPER: DisclaimerKeysMap = {
  [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_12ConsecutiveMonthlyRenewals]:
    "membershipWithInstallmentsDisclaimer.noWrapper.yearlyPaidMonthly",
  [AutoRenewalDeactivationCondition.DeactivationAllowedAfter_4ConsecutiveQuarterlyRenewals]:
    "membershipWithInstallmentsDisclaimer.noWrapper.yearlyPaidQuarterly",
};

export default DISCLAIMER_KEYS;
